/**
 * @Description 埋点共通方法
 */

import { isArray, treeFind } from '@lhb/func';
import { useContext } from 'react';
import UserInfoContext from '@/layout/context';

/**
 * @Description 埋点共通方法，用于locationPC端查看租户日志
 *
 * @param event_id 事件id
 * event_id 在埋点信息的在线文档中维护
 *  文档地址:
 *    https://doc.weixin.qq.com/sheet/e3_AdMAUgaSAGQzcXR1vSBSrSsIRqp7y?scode=ADMAmgftAAcPJUvksUAdMAUgaSAGQ&tab=000002
 * 文件sheet:
 *   event_id 列表
 *
 * @param op_menu_encode 菜单encode
 * @param op_menu 操作菜单 ex. 工作台-机会点
 * @param op_feat 操作功能 ex. 编辑
 * @param desc 文案 ex. 点击了机会点编辑
 * @param op_obj 其他埋点事件对象，目前有 0801新增op_block（模块）、op_event 事件对象（案例）. 加入了x个开店区域
 */
export function bigdataAction(
  event_id: string,
  op_menu_encode: number | string,
  op_menu: string,
  op_feat: string,
  desc: string,
  op_obj?: {
    [key: string]: any;
  },
) {
  const msg: any = {
    op_menu_encode: op_menu_encode || '',
    op_menu: op_menu || '',
    op_feat: op_feat || '',
    desc: desc || '',
    // op_event: op_event || '',
    ...(op_obj || {})
  };
  // console.log('bigdataAction', event_id, msg);
  window.LHBbigdata.send({
    event_id, // 事件id
    msg // 额外需要插入的业务信息
  });
}

/**
 * @description 菜单uri与埋点信息(event_id,菜单名)映射表
 */

const menuBigdataMap = {
  '/home/config': ['7626324f-ab31-41ef-a4ff-c58294ce079c', '首页看板', '左侧菜单', { op_block: '左侧菜单' }],
  '/map': ['5442cb35-cfb2-df63-3684-6879f6f2a08e', '选址地图', '左侧菜单', { op_block: '左侧菜单' }],
  '/selection/industry': ['834acca3-7362-4dc7-9c66-f1cbd94ad0eb', '竞品地图', '左侧菜单', { op_block: '左侧菜单' }],
  '/recommend/contrast': ['816ccf04-a5c4-4ede-b6f5-89c5f5acac68', '竞品对比', '左侧菜单', { op_block: '左侧菜单' }],
  '/surround': ['8f754d77-61db-4b89-81fe-bf5cc98e27d9', '周边配套', '左侧菜单', { op_block: '左侧菜单' }],
  '/storemap/universal': ['e13d4b07-a949-442b-933e-cb66137a48e2', '门店地图', '左侧菜单', { op_block: '左侧菜单' }],
  '/expandstore/expansiontask': ['af432ee8-f455-4ea1-ad8c-0ec9b720cab3', '拓店任务', '左侧菜单', { op_block: '左侧菜单' }],
  '/expandstore/franchisee': ['28fa5c13-7dcb-48b6-a80f-e0ddbecbbdf1', '加盟商管理', '左侧菜单', { op_block: '左侧菜单' }],
  '/expandstore/chancepoint': ['d343e2e0-8635-46f1-bccd-e81d648984c0', '机会点', '左侧菜单', { op_block: '左侧菜单' }],
  '/expandstore/shop': ['99454a3e-0d61-44ea-9ca0-30b145270020', '门店管理', '左侧菜单', { op_block: '左侧菜单' }],
  '/storemanage/progress': ['f37a7518-7e13-4a81-83bf-e9f070a57fbf', '拓店进展统计', '左侧菜单', { op_block: '左侧菜单' }],
  '/storemanage/devdptkpireport': ['bf9d2498-b0af-4279-bd09-d4ebb0eafb6e', '开发部绩效统计', '左侧菜单', { op_block: '左侧菜单' }],
  '/storemanage/individualkpireport': ['dde1f918-a2a9-440f-a4e4-c2c1953d2265', '个人绩效报表', '左侧菜单', { op_block: '左侧菜单' }],
  '/expandstore/approver': ['c3bc20df-c0ed-4328-be76-36fd2dfff048', '审批工作台', '左侧菜单', { op_block: '左侧菜单' }],
  '/expandstore/predictflow': ['', '客流预估', '左侧菜单', { op_block: '左侧菜单' }],
  '/system/log': ['cf2a05bc-5e9a-4862-8932-8366f835c218', '操作日志', '左侧菜单', { op_block: '左侧菜单' }],
  '/system/standardmigration': ['d5f7ac4c-a250-4b18-ae7e-07bd24c60fd4', '数据迁移', '左侧菜单', { op_block: '左侧菜单' }],
  '/recommend/networkplan': ['9f4444e0-3f55-4034-bbcb-2db1c3ee83fe', '规划管理', '左侧菜单', { op_block: '左侧菜单' }],
  '/recommend/branchnetworkplan': ['b60ae303-f664-4a70-9977-609f1733194e', '分公司规划管理', '左侧菜单', { op_block: '左侧菜单' }],
  '/recommend/collectmap': ['9486518d-effc-403d-bc59-29edd9f63d01', '集客点地图', '左侧菜单', { op_block: '左侧菜单' }],
  '/recommend/industrybusiness': ['d6893572-11c4-4f01-b499-e0a22245d5cd', '网规生效商圈', '左侧菜单', { op_block: '左侧菜单' }],
  '/youth/map': ['122baf28-a7e6-4e32-85f8-4f6bc5bccff7', '青春版', '左侧菜单', { op_block: '左侧菜单' }],
  '/spotevaluation': ['ab2f27b5-ae6c-42bb-b52e-98b1a7fa67ae', '点位测评', '左侧菜单', { op_block: '左侧菜单' }],
};

/**
 * @description 菜单事件埋点，按指定uri上报日志
 * @param uri 菜单设置的uri
 * @param menuEncode 菜单encode
 * @param menu 菜单名
 * @param feat 功能名
 * @param desc 描述文案
 */
export function bigdataMenu(
  uri: string,
  menuEncode: number | string,
  menu = '',
  feat = '',
  desc = ''
) {
  if (!uri || !menuEncode) return;

  const info = menuBigdataMap[uri];
  if (!isArray(info) || !info.length) return;
  const action = info.length ? info[0] as string : '';
  const op_menu = menu || (info.length > 1 ? info[1] as string : '');
  const op_feat = feat || (info.length > 2 ? info[2] as string : '');
  const op_desc = desc || op_menu ? `点击了${op_menu}` : '';
  const op_obj = info.length > 3 ? info[3] : {};
  bigdataAction(action, menuEncode, op_menu, op_feat, op_desc, op_obj);
}

/**
 * @Description 按钮事件埋点
 * @deprecated 弃用，请使用useBigdataFn hooks，自动传入 encode
 * @param event_id 事件id
 * @param op_menu 操作菜单 ex. 工作台-机会点
 * @param op_feat 操作功能 ex. 编辑
 * @param desc 文案 ex. 点击了机会点编辑
 * @param op_event 事件对象（案例) 。星巴克
 */
export function bigdataBtn(
  event_id: string,
  op_menu: string,
  op_feat: string,
  desc: string,
  op_obj:{
    op_event?:string,
    op_block?:string,
  }
) {
  bigdataAction(event_id, '', op_menu, op_feat, desc, op_obj);
}

export interface UseBigdataObjParams {
  event_id: string,
  op_feat: string,
  desc: string,
  op_obj?: {
    op_event?: string,
    op_block?: string,
  }
}

/**
 * @Description 按钮事件埋点
 * op_menu 从userInfo取，如果是分享页或者没有配置菜单的跳转页可以使用bigdataAction
 * isCheckUserInfo 是否校验获取到use
 * @param event_id 事件id
 * @param op_feat 操作功能 ex. 编辑
 * @param desc 文案 ex. 点击了机会点编辑
 * @param op_event 事件对象（案例) 。星巴克
 */
export function useBigdataFn(isCheckUserInfo = false) {

  const userInfo: any = useContext(UserInfoContext); // 获取用户信息
  const op_menu = userInfo.moduleList ? treeFind(userInfo.moduleList, (item: any) => item.uri === window.location.pathname) : {};

  const handleBigdataBtn = (
    event_id: string,
    op_feat: string,
    desc: string,
    op_obj?: {
      op_event?: string,
      op_block?: string,
    }
  ) => {
    // 是否校验userInfo数据已经获取成功（目前主要用在地图场景中，用来解决页面初始化时，地图绑定了zoomend、moveend等事件时，userInfo还未获取到就执行了埋点上报，导致op_menu未获取到）
    if (isCheckUserInfo) {
      op_menu && Object.keys(op_menu).length && bigdataAction(event_id, op_menu?.encode, op_menu?.name, op_feat, desc, op_obj); // 传递 encode
      return;
    }
    bigdataAction(event_id, op_menu?.encode, op_menu?.name, op_feat, desc, op_obj); // 传递 encode
  };

  return handleBigdataBtn as any; // 返回处理函数
}
